import format from "date-fns/format"
import isDate from "date-fns/isDate"
import parseISO from "date-fns/parseISO"
import moment from "moment"
import business from "moment-business"
import { Component, Prop, Vue } from "vue-property-decorator"

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export const mask = (value, pattern) => {
  if (!value) {
    return ""
  }

  if (typeof pattern === "string") {
    let i = 0
    const v = value.toString()

    return pattern.replace(/#/g, () => {
      const char = v[i] ?? ""
      i += 1
      return char
    })
  }

  return value
}

export const validateCPF = (cpf) => {
  const filteredCpf = filterDocument(cpf)
  if (filteredCpf === "") {
    return false
  }

  if (
    filteredCpf === "00000000000" ||
    filteredCpf === "11111111111" ||
    filteredCpf === "22222222222" ||
    filteredCpf === "33333333333" ||
    filteredCpf === "44444444444" ||
    filteredCpf === "55555555555" ||
    filteredCpf === "66666666666" ||
    filteredCpf === "77777777777" ||
    filteredCpf === "88888888888" ||
    filteredCpf === "99999999999"
  ) {
    return false
  }

  // validates first digit
  let add = 0
  for (let i = 0; i < 9; i++) {
    add += Number.parseInt(filteredCpf.charAt(i), 10) * (10 - i)
  }
  let rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) {
    rev = 0
  }
  if (rev !== Number.parseInt(filteredCpf.charAt(9), 10)) {
    return false
  }

  // validates second digit
  add = 0
  for (let i = 0; i < 10; i++) {
    add += Number.parseInt(filteredCpf.charAt(i), 10) * (11 - i)
  }
  rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) {
    rev = 0
  }
  if (rev !== Number.parseInt(filteredCpf.charAt(10), 10)) {
    return false
  }
  return true
}

const repeatedCharactersRegex = /^([A-Z0-9])\1+$/

export const validateCNPJ = (cnpj) => {
  if (!cnpj) {
    return false
  }

  // Remove non-alphanumeric characters
  const cleaned = cnpj.replace(/[^A-Z0-9]+/gi, "").toUpperCase()

  if (cleaned.length !== 14) {
    return false
  }

  // Reject repeated sequences (e.g., AAA..., 111..., etc.)
  if (repeatedCharactersRegex.test(cleaned)) {
    return false
  }

  // Helper: convert char to numeric value
  const charToValue = (char) => char.charCodeAt(0) - 48

  // First check digit
  let size = 12
  let sum = 0
  let pos = size - 7

  for (let i = 0; i < size; i++) {
    sum += charToValue(cleaned[i]) * pos
    pos = pos === 2 ? 9 : pos - 1
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11)

  if (result !== charToValue(cleaned[12])) {
    return false
  }

  // Second check digit
  size = 13
  sum = 0
  pos = size - 7

  for (let i = 0; i < size; i++) {
    sum += charToValue(cleaned[i]) * pos
    pos = pos === 2 ? 9 : pos - 1
  }

  result = sum % 11 < 2 ? 0 : 11 - (sum % 11)

  if (result !== charToValue(cleaned[13])) {
    return false
  }

  return true
}

export const dateFormat = (date, withTime = false) => {
  if (isDate(date)) {
    return format(date, withTime ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy")
  }
  if (typeof date === "string") {
    return format(parseISO(date), withTime ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy")
  }
  return date
}

export const hourFormat = (time) => {
  const times = time.split(":")
  return [times[0], times[1]].join(":")
}

export const filterDocument = (string) => string.replace(/[/.-]/g, "").trim()

export const filterId = (string) => string.replace(/\D/g, "").trim().slice(0, 8)

/** Mimicking Bootstrap 4 Collapse */
const fnmap = {
  toggle: "toggle",
  show: "add",
  hide: "remove",
}

export const collapse = (selector, cmd) => {
  const targets = Array.from(document.querySelectorAll(selector))
  for (const target of targets) {
    target.classList[fnmap[cmd]]("show")
  }
}

export const tftDueDate = () => {
  const now = moment()
  const tenth = moment().date(10)
  const lastDay = moment().endOf("month")

  if (business.weekDays(now, tenth) < 5 || now.diff(tenth, "days") >= 0) {
    const date = business.addWeekDays(moment(), 5)
    if (date.diff(lastDay, "days") > 0) {
      return lastDay
    }
    return date
  }
  return tenth
}

@Component
export class StatusBadge extends Vue {
  @Prop({ default: "" })
  string

  render() {
    if (
      ["Cancelado", "Cancelada", "Inválido", "Em aberto"].includes(this.string)
    ) {
      return <span class="badge badge-danger">{this.string}</span>
    }
    if (
      [
        "Finalizado",
        "Pago",
        "Ativo",
        "Ativa",
        "Suspenso judicialmente",
        "Impresso",
        "Impressa",
      ].includes(this.string)
    ) {
      return <span class="badge badge-success">{this.string}</span>
    }
    if (
      [
        "Solicitado",
        "Suspenso",
        "Vencido",
        "Vencida",
        "Aguardando Pagamento",
      ].includes(this.string)
    ) {
      return <span class="badge badge-warning">{this.string}</span>
    }
    return <span class="badge badge-default">{this.string}</span>
  }
}
